import { combineReducers } from 'redux';
import navigationReducer from './features/navigation';
import companyMainReducer from './features/company';

const rootReducer = combineReducers({
  navigation: navigationReducer,
  company: companyMainReducer,
});

export default rootReducer;
